<template>
  <v-row>
    <v-col>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <template v-for="(item, index) of headers">
                <th
                  :key="index.toString()"
                  class="text-left table-tcdc-header table-content-tcdc-color"
                >{{ item[`text_${lang}`] }}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in membersBenefit" :key="item.id">
              <td v-html="item[`detail_${lang}`] ? item[`detail_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 pl-0 ml-0 mr-12  table-content-tcdc-color vhtml"
              ></td>
              <td v-html="item[`rate_${lang}`] ? item[`rate_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color vhtml"
              ></td>
              <td v-html="item[`discount_${lang}`] ? item[`discount_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color vhtml"
              ></td>
              <td v-html="item[`service_${lang}`] ? item[`service_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color vhtml"
              ></td>
              <td v-html="item[`meeting_room_${lang}`] ? item[`meeting_room_${lang}`] : '-'"
                class="table-tcdc-vertical-align-top py-2 mx-12  table-content-tcdc-color vhtml"
              ></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      membersBenefit: state => {
        return state.ServiceMenu.membership_benefit
      },
      lang: state => state.Branch.lang
    })
  },
  created() {
  },
  methods:{

  },
  data: () => ({
    headers: [
      {
        text_th: "สมาชิก",
        text_en: "Membership",
        align: "start",
        value: "name"
      },
      { text_th: "ราคา", text_en: "Rate", value: "rate" },
      { text_th: "ส่วนลด", text_en: "Discount", value: "discount" },
      { text_th: "บริการ", text_en: "Service", value: "service" },
      { text_th: "ห้องประชุม", text_en: "Meeting Room", value: "meetingRoom" }
    ],
    bodys: [],
  })
};
</script>

<style lang="scss" scoped>
th,
td {
  min-width: 100px;
}
td {
  padding-top: 20px;
  padding-bottom: 30px;
}

.table-tcdc-header:first-child {
  padding-left: 0px;
}
.table-content-tcdc-color {
  color: $tcdcGrey1;
}
.table-tcdc-vertical-align-top {
  vertical-align: top;
}
</style>
